import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import Container from "../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import {
  ACTIVITY_TYPE,
  HttpStatus,
  INITIAL_DATE,
  INITIAL_PAGINATION,
} from "../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../common/mapper";
import { getMainPageTableConfig } from "./config";
import SimpleDate from "../../../modules/SimpleDate";
import moment from "moment";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../modules/custom/customTable";
import PoPartDetail from "./poPartDetail";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import PoPartFilter from "./poPartFilter";

const INITIAL_SEARCH_DATA = {
  startDate: INITIAL_DATE,
  endDate: INITIAL_DATE,
};

class PoPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      loading: false,
      userAccess: [],
      pagination: INITIAL_PAGINATION,
      // skipNextFetch: false,
      submitedFilter: null,
      searchData: INITIAL_SEARCH_DATA,
      detail: {
        visible: false,
        selectedData: null,
        activityType: null,
      },
      alertInfo: {
        visible: false,
        title: null,
        content: null,
        type: null,
      },
      filterVisible: false,
      confirmVisible: false,
      pendingClose: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevState?.searchData?.kodeCabang?.value;
    const currCabang = this.state?.searchData?.kodeCabang?.value;

    if (prevCabang !== currCabang) {
      this.setState((prev) => ({
        ...prev,
        pagination: INITIAL_PAGINATION,
        searchData: {
          ...prev.searchData,
          ...INITIAL_SEARCH_DATA,
        },
        // skipNextFetch: true,
        userAccess: getUserAccess(this.props.menuAccess, currCabang),
      }));

      this.fetchData(
        {
          ...INITIAL_SEARCH_DATA,
          kodeCabang: currCabang,
        },
        5,
        1,
      );
    }

    const prevPagination = prevState.pagination;
    const currPagination = this.state.pagination;
    
    if (
      prevPagination.page !== currPagination.page ||
      prevPagination.limit !== currPagination.limit
    ) {
      let filter = this.state.searchData;
    
      if (this.state.submitedFilter) {
        filter = {
          ...filter,
          ...this.state.submitedFilter,
        };
      }
    
      this.fetchData(
        removeNullFields(filter),
        currPagination.limit,
        currPagination.page,
      );
    }
  }

  fetchDataCabang = async () => {
    const { setError, menuAccess } = this.props;

    this.handleTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: setError,
      menuName: "PO Part",
      args: {},
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res.data.data.filter((item) =>
        menuAccess.map((data) => data.idRefObj).includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang),
          ),
          searchData: {
            ...prevValue.searchData,
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
          },
          userAccess: getUserAccess(
            menuAccess,
            filteredData[0].kodeCabang.value,
          ),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  fetchData = async (filter = {}, limit, page) => {
    const { setError } = this.props;
    this.handleTriggerLoading();

    const payload = removeNullFields({
      ...filter,
      ...(filter?.poMonth ? { poMonth: filter?.poMonth?.format("MMMM") } : {}),
      ...(filter.partCategory
        ? { partCategory: filter.partCategory?.value }
        : {}),
      kodeCabang: this.state.searchData?.kodeCabang?.value || null,
      limit: limit,
      page: page,
    });

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getPoPartMainPage,
      menuName: "PO Part",
      setError,
      args: payload,
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({
      ...prev,
      loading: !prev.loading,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prev) => ({
      ...prev,
      searchData: {
        ...prev.searchData,
        kodeCabang: value,
      },
    }));
  };

  handleSearchChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      searchData: {
        ...prev.searchData,
        [name]: value,
      },
    }));
  };

  handleSearch = async () => {
    this.setState({
      pagination: INITIAL_PAGINATION,
      // skipNextFetch: true,
    }, () => {
      this.fetchData(
        { ...this.state.searchData },
        5,
        1
      );

      // this.setState({ skipNextFetch: false });
    });
  };

  handleChangePage = (value) => {
    const page = typeof value === "number"
      ? value + 1
      : value?.page + 1;

    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: page || 1,
      },
    }));
  };

  handleChangeRowsPerPage = (value) => {
    const limit =
      typeof value === "number"
        ? value
        : value?.rowsPerPage;
    
    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: 1,
        limit: Number(limit) || 5,
      },
    }));
  };

  getTableConfig = () => {
    return getMainPageTableConfig({
      onShowDetail: this.handleDetailVisibility,
      userAccess: this.state.userAccess,
      pagination: this.state.pagination,
    });
  };

  handleDetailVisibility = (index, activityType, data) => {
    if (
      this.state.detail.visible &&
      this.state.detail.activityType === ACTIVITY_TYPE.CREATE
    ) {
      this.setState({
        // confirmVisible: true,
        pendingClose: true,
      });
      return;
    }

    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        visible: !prev.detail?.visible,
        selectedData: prev.dataTable[index],
        activityType: activityType || null,
        data: data || null,
      },
    }));
  };

  handleCloseDetail = () => {
    this.setState({
      confirmVisible: true,
    });
  };

  handleAlertInfo = (title, content, type) => {
    console.log(content);

    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        // visible: !prev.alertInfo.visible,
        visible: true,
        title: title,
        content: content,
        type: type || null,
      },
    }));
  };

  closeAlertInfo = () => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: false,
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      filterVisible: !prev.filterVisible,
    }));
  };

  handleSubmitFilter = (payload) => {
    this.setState({
      submitedFilter: removeNullFields(payload),
      // skipNextFetch: true,
      pagination: INITIAL_PAGINATION,
    }, () => {
      this.fetchData(payload, 5, 1);
      // this.setState({ skipNextFetch: false });
    });
  };

  handleRefresh = () => {
    const { pagination, searchData, submitedFilter } = this.state;

    let filter = { ...searchData };

    if (submitedFilter) {
      filter = {
        ...filter,
        ...submitedFilter,
      };
    }

    this.fetchData(removeNullFields(filter), pagination.limit, pagination.page);
  };

  handleCloseConfirmDelete = () => {
    this.setState({ confirmVisible: false, pendingClose: false });
  };

  handleConfirmCloseDetail = () => {
    this.setState((prev) => ({
      ...prev,
      confirmVisible: false,
      pendingClose: false,
      detail: {
        ...prev.detail,
        visible: false,
      },
    }));
  };

  handleForceCloseDetail = () => {
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        visible: false,
        selectedData: null,
        activityType: null,
        data: null,
      },
    }));
  };

  render() {
    const {
      cabangOptions,
      searchData,
      loading,
      dataTable,
      pagination,
      detail,
      alertInfo,
      filterVisible,
      submitedFilter,
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView column className="margin-bottom-15px">
            <FlexView vAlignContent="center" style={{ gap: "15px" }}>
              <p className="margin-bottom-15px">Cabang</p>
              <SimpleDDL
                id="dropdown_cabang"
                name="kodeCabang"
                box="search"
                containerclassname="width width-280px"
                placeholder="Kode Cabang"
                options={cabangOptions}
                value={searchData.kodeCabang}
                onChange={(value) => this.handleChangeCabang(value)}
              />
            </FlexView>
            <FlexView
              vAlignContent="center"
              style={{ justifyContent: "space-between" }}
            >
              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <p className="margin-bottom-15px">Periode</p>
                <SimpleDate
                  id="date_picker_start_date"
                  name="startDate"
                  date={searchData.startDate}
                  nextdate
                  maxDate={searchData.endDate}
                  onChange={(value) =>
                    this.handleSearchChange(
                      "startDate",
                      moment(value).format("DD-MM-YYYY"),
                    )
                  }
                />
                <p className="margin-bottom-15px">s/d</p>
                <SimpleDate
                  id="date_picker_end_date"
                  name="endDate"
                  date={searchData.endDate}
                  minDate={searchData.startDate}
                  onChange={(value) =>
                    this.handleSearchChange(
                      "endDate",
                      moment(value).format("DD-MM-YYYY"),
                    )
                  }
                />
                <SimpleButton
                  id="btn_search"
                  text="Cari"
                  className="margin-bottom-15px"
                  onClick={() => this.handleSearch()}
                />
              </FlexView>
              <SimpleButton
                type="button"
                category="action_button"
                className="btn background-red margin-bottom-20px"
                onClick={this.handleFilterVisibility}
                icon={<i className="fa fa-qrcode"></i>}
              />
            </FlexView>

            {/* <SimpleDataTable
              id="id_table_po"
              data={dataTable}
              columns={this.getTableConfig()}
              toCount={pagination.totalData}
              rowsPerPage={pagination.limit}
              page={pagination.page - 1}
              options={defaultTableChange(
                this.handleChangePage,
                this.handleRowsPerPage
              )}
              footerAdditionalButtons={
                <SimpleButton
                  text="Tambah"
                  icon={<i className="fa fa-plus margin-right-5px" />}
                  onClick={() =>
                    this.handleDetailVisibility(null, ACTIVITY_TYPE.CREATE)
                  }
                />
              }
            /> */}
            <SimpleDataTable
              key={`${pagination.totalData}-${pagination.page}-${pagination.limit}`}
              id="id_table_po"
              data={dataTable || []}
              columns={this.getTableConfig()}
              toCount={Number(pagination?.totalData) || 0}
              rowsPerPage={Number(pagination?.limit) || 5}
              page={(Number(pagination?.page) || 1) - 1}
              options={defaultTableChange(
                this.handleChangePage,
                this.handleChangeRowsPerPage
              )}
              footerAdditionalButtons={
                this.state.userAccess?.createAccess && (
                  <SimpleButton
                    text="Tambah"
                    icon={<i className="fa fa-plus margin-right-5px" />}
                    onClick={() =>
                      this.handleDetailVisibility(null, ACTIVITY_TYPE.CREATE)
                    }
                  />
                )
              }
            />
          </FlexView>
        </Container>
        {detail.visible && (
          <PoPartDetail
            {...this.props}
            selectedData={detail.data}
            activityType={detail.activityType}
            visible={detail.visible}
            cabangOptions={cabangOptions}
            kodeCabang={searchData?.kodeCabang}
            onTriggerAlert={this.handleAlertInfo}
            onTriggerLoading={this.handleTriggerLoading}
            // onClickClose={this.handleDetailVisibility}
            // onClickClosePopup={this.handleCloseDetail}
            onClickClose={this.handleForceCloseDetail}
            onClickClosePopup={this.handleCloseDetail}
            onRefresh={this.handleRefresh}
          />
        )}
        {filterVisible && (
          <PoPartFilter
            {...this.props}
            visible={filterVisible}
            submitedFilter={submitedFilter}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {alertInfo.visible && (
          <SimpleAlert
            visible={alertInfo.visible}
            title={alertInfo.title}
            onClickClose={this.closeAlertInfo}
            content={alertInfo.content}
            additionalButtons={
              <SimpleButton text="OK" onClick={this.closeAlertInfo} />
            }
          />
        )}

        {this.state.confirmVisible && (
          <SimpleAlert
            title="Konfirmasi Hapus"
            content={
              <div>
                <p>
                  Saat keluar data pada header tidak dapat diubah? Apakah anda
                  yakin
                </p>
              </div>
            }
            visible={this.state.confirmVisible}
            onClickClose={this.handleCloseConfirmDelete}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Tidak"
                  onClick={this.handleCloseConfirmDelete}
                />

                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Ya"
                  onClick={this.handleConfirmCloseDetail}
                />
              </FlexView>
            }
          />
        )}

        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(ErrorAction.setError(payload)),
});

export default connect(null, mapDispatchToProps)(PoPart);
